var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('v-card',{staticClass:"pa-5 card"},[_c('h1',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$t("subscribeTitle")))]),_c('SubscribeForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }